import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import GeneralSettings from "./components/GeneralSettings";
import AlertRules from "./components/AlertRules";
import SystemIntegrations from "./components/SystemIntegrations";
import Integrations from "./components/Integrations";
import "./configuration.scss";

export default function Configuration() {
  const { tab } = useParams();
  const navigate = useNavigate();

  const tabs = [
    { id: "general", label: "General" },
    { id: "email-notifications", label: "Email Notifications" },
    { id: "workspaces", label: "WorkSpaces" },
    { id: "integrations", label: "Integrations" },
  ];

  // Valid tabs - default to "general" if invalid tab in URL
  const validTabs = tabs.map((t) => t.id);
  const selectedTab = validTabs.includes(tab) ? tab : "general";

  return (
    <div className="configuration">
      {/* Page Header */}
      <div className="configuration__header">
        <div>
          <h1 className="configuration__title">Configuration</h1>
          <p className="configuration__subtitle">
            System settings and security configurations
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="configuration__tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`configuration__tab ${
              selectedTab === tab.id ? "configuration__tab--active" : ""
            }`}
            onClick={() => navigate(`/configuration/${tab.id}`)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="configuration__content">
        {selectedTab === "general" && <GeneralSettings />}
        {selectedTab === "email-notifications" && <AlertRules />}
        {selectedTab === "workspaces" && <SystemIntegrations />}
        {selectedTab === "integrations" && <Integrations />}
      </div>
    </div>
  );
}
